import { useI18n } from '../../../shared/i18n/useI18n.js';

import { Button } from '../../../shared/ui/Button/index.js';
import { Share } from '../../../shared/ui/icons/index.js';

import styles from './FavoritesTopBar.module.scss';

/**
 * Favorites section top bar with count, hidden-info badge, and clear-all action.
 */
export function FavoritesTopBar({
	favoritesCount = 0,
	hiddenFavoritesCount = 0,
	areSomeFavoritesHidden = false,
	onClearAll,
	onInquireAll,
}) {
	// ── i18n ──────────────────────────────────────────────────────────────────
	const { t } = useI18n();

	// ── Derived state ─────────────────────────────────────────────────────────
	const isClearDisabled =
		favoritesCount === 0 || typeof onClearAll !== 'function';

	// ── Render ────────────────────────────────────────────────────────────────
	return (
		<div className={styles.topBar}>
			<div className={styles.headerBox}>
				<div className={styles.headerGroup}>
					<span className={styles.heading}>{t('favorites.heading')}</span>
					<span className={styles.count}>{` (${favoritesCount})`}</span>
				</div>
				{areSomeFavoritesHidden && hiddenFavoritesCount > 0 && (
					<div className={styles.meta}>
						<span className={styles.badge}>
							{t('favorites.hidden_count', { count: hiddenFavoritesCount })}
						</span>
					</div>
				)}
			</div>
			<div className={styles.toolsGroup}>
				<Button
					type="button"
					kind="text"
					size="large"
					disabled={isClearDisabled}
					onClick={onClearAll}
				>
					{t('favorites.clear_all')}
				</Button>
				<Button type="button" kind="text" size="large" cta onClick={onInquireAll}>
					{t('favorites.send_inquiry_all')}
				</Button>
				<div className={styles.actionCell}>
					{/* <Button type="button" kind="icon" size="large" cta>
						<Share />
					</Button> */}
				</div>
			</div>
		</div>
	);
}
